import { ColumnConfig, ColumnDataType } from '@aurora';

export const operatorColumnsConfig: ColumnConfig[] = [
    {
        type           : ColumnDataType.STRING,
        field          : 'account.user.name',
        searchableField: '$account.user.name$',
        sort           : 'account.user.name',
        translation    : 'Name',
        isUnaccent     : true,
    },
    {
        type           : ColumnDataType.STRING,
        field          : 'account.user.surname',
        searchableField: '$account.user.surname$',
        sort           : 'account.user.surname',
        translation    : 'Surname',
        isUnaccent     : true,
    },
    {
        type           : ColumnDataType.STRING,
        field          : 'account.email',
        searchableField: '$account.email$',
        sort           : 'account.email',
        translation    : 'Email',
        isUnaccent     : true,
    },
    {
        type           : ColumnDataType.STRING,
        field          : 'account.username',
        searchableField: '$account.username$',
        sort           : 'account.username',
        translation    : 'Username',
        isUnaccent     : true,
    },
];
